import styled, { css } from 'styled-components'

import { style } from 'theme'

const FormContainer = styled.div<{ laterSuitability?: boolean }>`
  padding-bottom: 80px;
  margin: 0 auto;

  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 60%;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 23px;
  }

  label:last-child {
    margin-bottom: 0;
    margin-top: 0;
  }

  & > div:first-child .investor-checkbox > label:last-child {
    margin-top: 0;
  }

  & > div:not(:last-child) .investor-checkbox {
    padding-bottom: 0;

    label:last-child {
      margin-bottom: 11px;
    }
  }

  .signup-checkbox {
    @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
      padding: 0;
    }
    padding: 0 2rem;
    span:not(:first-child) {
      position: relative;
    }
    span {
      position: relative &>span {
        position: absolute;
      }
    }
    label {
      span {
        margin-top: 0;
        div {
          margin-top: 0;
          line-height: 1.83;
        }
      }
    }
    &.resident-checkbox {
      padding-bottom: 0;
    }
    &.esign-checkbox {
      padding-bottom: 10px;
    }
  }

  ${props =>
    props.laterSuitability &&
    css`
      margin: auto;
      max-width: 400px;
      padding-bottom: 0;

      & > div > div:last-child > div {
        padding-bottom: 10px;

        & > div:last-child {
          bottom: 10px;
        }

        @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
          padding-bottom: 20px;

          & > div:last-child {
            bottom: 20px;
          }
        }
      }
    `}
`

export default FormContainer
